export default "__VITE_PUBLIC_ASSET__9563d100__"